import { Button } from "components/ui/controls/Button"
import { SwitchRow } from "components/ui/controls/SwitchRow"
import { ContentContainer } from "components/ui/display/ContentContainer"
import { Input } from "components/ui/inputs/Input"
import { PasswordStrength } from "components/ui/inputs/PasswordStrength"
import { AppLogo } from "components/ui/shared/AppLogo"
import { MaterialIcon } from "components/ui/shared/MaterialIcon"
import { TermsOfUse } from "components/ui/shared/TermsOfUse"
import { useErrors } from "providers/ErrorsProvider"
import { useApi } from "providers/UserProvider"
import { useEffect, useRef, useState } from "react"
import { replace, useNavigate } from "react-router-dom"
import styled from "styled-components"

export const UserActivation = () => {

    const navigate = useNavigate();
    const [activationCredentials, setActivationCredentials] = useState({
        username: '',
        securityCode: '',
        userUuid: ''
    });
    const [isSearchingForUser, setIsSearchingForUser] = useState(false);
    const [validUserCredentials, setValidUserCredentials] = useState({
        username: null,
        userUuid: null,
        userEmail: null,
        userFullName: null
    });

    const {setError, unsetError} = useErrors();
    const {api} = useApi();

    const activateUser = async () => {
        if(activationCredentials.username.trim().length < 6
        || activationCredentials.securityCode.trim().length < 4
        || activationCredentials.userUuid.trim().length < 36)
        {
            setError("ACCESS_ACTIVATION_DETAILS_TOO_SHORT");
            return;
        }

        unsetError("ACCESS_ACTIVATION_DETAILS_TOO_SHORT");

            
        try
        {
            setIsSearchingForUser(true);
            const res = await api.request('access/activate', {
                username: activationCredentials.username.trim(),
                securityCode: activationCredentials.securityCode.trim(),
                userUuid: activationCredentials.userUuid.trim(),
            });

            console.log(res);
            if(res.status === "USER_FOUND")
            {
                console.log('123');
                unsetError("ACCESS_ACTIVATION_USER_BLOCKED");
                unsetError("ACCESS_ACTIVATION_USER_ACTIVE");
                unsetError("ACCESS_ACTIVATION_USER_NOT_FOUND");

                setValidUserCredentials({
                    username: activationCredentials.username.trim(),
                    userUuid: activationCredentials.userUuid.trim(),
                    userEmail: res.userEmail,
                    userFullName: res.userFullName
                })
            }
        }
        catch(error)
        {
            const res = error.body;
            if(res.status === "USER_NOT_FOUND")
            {
                setError("ACCESS_ACTIVATION_USER_NOT_FOUND");
                unsetError("ACCESS_ACTIVATION_USER_ACTIVE");
                unsetError("ACCESS_ACTIVATION_USER_BLOCKED");

            }
            else if(res.status === 'USER_ACTIVE')
            {
                setError("ACCESS_ACTIVATION_USER_ACTIVE");
                unsetError("ACCESS_ACTIVATION_USER_BLOCKED");
                unsetError("ACCESS_ACTIVATION_USER_NOT_FOUND");
            }
            else if(res.status === 'USER_BLOCKED')
            {
                setError("ACCESS_ACTIVATION_USER_BLOCKED");
                unsetError("ACCESS_ACTIVATION_USER_ACTIVE");
                unsetError("ACCESS_ACTIVATION_USER_NOT_FOUND");
            }
        }
        finally
        {
            setIsSearchingForUser(false);
        }   
    }


    return (
        validUserCredentials.username && validUserCredentials.userUuid && validUserCredentials.userEmail && validUserCredentials.userFullName ?
        <>
            <UserPasswordWizard credentials={validUserCredentials}/>
        </>
        :
        <StyledUserActivation>
                <AppLogo orientation="vertical" size='lg'/>
                <div className="authDescription">
                    Aktivering av bruker
                </div>
                <ContentContainer
                    padding="lg"
                    marginTop='lg'
                    marginBottom='lg'
                    contentGap="lg"
                    className='loginContainer'
                >

                <div className="inputDescription">
                    Skriv inn brukernavn (6 tegn), sikkerhetskode (4 tegn) og personlig identifikasjonskode (36 tegn inkludert bindestrek). Brukernavn og koder ble sendt til tilkoblet epost adresse.
                </div>
                <div className="userNameContainer">
                    <Input
                        className='usernameInput'
                        title='Brukernavn'
                        prefix={<MaterialIcon name='person' weight={300}/>}
                        value={activationCredentials.username}
                        onChange={(e) => setActivationCredentials(prev => ({...prev, username: e.target.value}))}
                    />

                    <Input
                        className='sidInput'
                        title='Sikkerhetskode'
                        prefix={<MaterialIcon name='terminal_2' weight={300}/>}
                        value={activationCredentials.securityCode}
                        onChange={(e) => setActivationCredentials(prev => ({...prev, securityCode: e.target.value}))}
                    />

                </div>
                <div>
                    <Input
                        className='uuidInput'
                        title='Identifikasjonsnummer'
                        prefix={<MaterialIcon name='terminal_2' weight={300}/>}
                        value={activationCredentials.userUuid}
                        onChange={(e) => setActivationCredentials(prev => ({...prev, userUuid: e.target.value}))}
                    />
                </div>
                <div className="options">
                    <Button
                        type='tertiary'
                        text='Tilbake'
                        prefix={<MaterialIcon name='arrow_back' weight={300}/>}
                        onClick={() => navigate('/')}
                    />
                    <Button
                        type='primary'
                        disabled={isSearchingForUser}
                        prefix={isSearchingForUser ? <MaterialIcon className='progressIcon' name='progress_activity' weight={300}/> : null}
                        text='Fortsett'
                        onClick={activateUser}
                    />
                </div>

                </ContentContainer>
            </StyledUserActivation>
        
    )
}

const StyledUserActivation = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({theme}) => theme.spacing.md};
    max-width: fit-content;

    @keyframes rotateProgress {
        from { transform: rotate(0deg) }
        to { transform: rotate(360deg) }
    }

    div.authDescription
    {
        font-weight: 400;
    }

    div.loginContainer
    {
        width: fit-content;

        div.inputDescription
        {
            color: ${({theme}) => theme.colors.mutedForeground};
            max-width: 500px;
        }

        div.userNameContainer
        {
            display: flex;
            flex-wrap: wrap;
            gap: ${({theme}) => theme.spacing.lg};
            

            .usernameInput, .sidInput
            {
                flex: 1;
            }
        }
    }

    div.options
    {
        display: flex;
        justify-content: flex-end;
        flex-direction: row;
        gap: ${({theme}) => theme.spacing.md};

        .progressIcon
        {
            animation-name: rotateProgress;
            animation-duration: 4s;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
        }
    }
`

const UserPasswordWizard = ({credentials}) => {

    const leftRef = useRef(null);
    const rightRef = useRef(null);
    const {setError, unsetError} = useErrors();
    const {api} = useApi();
    const navigate = useNavigate();

    useEffect(() => {
        if(!leftRef.current || !rightRef.current) return;

        rightRef.current.style.height = leftRef.current.offsetHeight + 'px';
    }, [leftRef, rightRef])

    const [passwords, setPasswords] = useState({
        firstPassword: '',
        secondPassword: ''
    });

    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [isTermsOfUseValid, setIsTermsOfUseValid] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    const setPassword = async (e) => {
        e.preventDefault();

        if(!isPasswordValid)
        {
            setError("ACCESS_ACTIVATION_PASSWORD_NOT_VALID");
            return;
        }
        
        if(!isTermsOfUseValid)
        {
            setError("ACCESS_ACTIVATION_TERMS_OF_USE_NOT_VALID");
            return;
        }

        unsetError("ACCESS_ACTIVATION_TERMS_OF_USE_NOT_VALID");
        unsetError("ACCESS_ACTIVATION_PASSWORD_NOT_VALID");
        
        try
        {
            setIsProcessing(true);
            const res = await api.request('access/setPassword',
                {
                    userUuid: credentials.userUuid,
                    userPassword: passwords.firstPassword
                }
            );

            unsetError("ACCESS_ACTIVATION_USER_NOT_ACTIVATED");

            if(res.status === "USER_ACTIVATED")
            {
                setError("ACCESS_ACTIVATION_USER_ACTIVATED");
                setTimeout(() => {
                    navigate('/', replace);
                }, 3000);
                
            }
        }
        catch(error)
        {
            const res = error.body;
            if(res.status === "USER_NOT_FOUND")
            {
                setError("ACCESS_ACTIVATION_USER_NOT_ACTIVATED");
            }
        }
        finally
        {
            setIsProcessing(false);
        }

        
    }

    return (
        <StyledUserPasswordWizard>
            <ContentContainer
                ref={leftRef}
                className={'left'}
                padding="lg"
                contentGap='lg'
            >
                <div className="userInfo">
                    <div className="userIcon">
                        {credentials.userFullName[0]}
                    </div>
                    <div className="userCredentials">
                        <div className="userFullName">
                            {credentials.userFullName}
                        </div>
                        <div className="userEmail">
                            {credentials.userEmail}
                        </div>
                    </div>
                </div>

                <form className="passwordWizardForm">
                    <Input
                        disabled={true}
                        value={credentials.username}
                        prefix={<MaterialIcon name='person' weight={300}/>}
                        title={'Brukernavn'}
                    />
                    <Input
                        type='password'
                        prefix={<MaterialIcon name='lock' weight={300}/>}
                        title={'Passord'}
                        value={passwords.firstPassword}
                        onChange={(e) => setPasswords(prev => ({...prev, firstPassword: e.target.value}))}
                    />
                    <Input
                        type='password'
                        prefix={<MaterialIcon name='lock' weight={300}/>}
                        title={'Gjenta passord'}
                        value={passwords.secondPassword}
                        onChange={(e) => setPasswords(prev => ({...prev, secondPassword: e.target.value}))}
                    />
                    <PasswordStrength
                        firstPassword={passwords.firstPassword}
                        secondPassword={passwords.secondPassword}
                        setPasswordValidFunction={setIsPasswordValid}
                    />
                    <Button
                        type="primary"
                        text={"Fortsett"}
                        disabled={isProcessing}
                        prefix={isProcessing ? <MaterialIcon className='progressIcon' name='progress_activity' weight={300}/> : null}
                        onClick={setPassword}
                    />
                </form>

            </ContentContainer>
            <ContentContainer
                ref={rightRef}
                className={'right'}
            >
                <div className="terms">
                    <TermsOfUse/>
                </div>
                <SwitchRow
                    icon={<MaterialIcon name='policy' weight={300}/>}
                    title="Aksepter brukervilkår"
                    isChecked={isTermsOfUseValid}
                    onChange={(e) => setIsTermsOfUseValid(e.target.checked)}
                />
            </ContentContainer>            
        </StyledUserPasswordWizard>
    )
}

const StyledUserPasswordWizard = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: ${({theme}) => theme.spacing.lg};
    flex-wrap: wrap;

    @keyframes rotateProgress {
        from { transform: rotate(0deg) }
        to { transform: rotate(360deg) }
    }

    .left
    {
        width: ${({theme}) => theme.breakPoints.xs};

        div.userInfo
        {
            display: flex;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};

            div.userIcon
            {
                flex: 0 0 26px;
                height: 26px;
                width: 26px;
                background: ${({theme}) => theme.colors.neutralPrimaryForeground};
                color: ${({theme}) => theme.colors.neutralPrimaryBackground}; 
                font-weight: 600;
                font-size: ${({theme}) => theme.fontSize.lg};

                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: ${({theme}) => theme.cornerRadius.md};
            }

            div.userFullName
            {
                font-weight: 600;
            }

            div.userEmail
            {
                color: ${({theme}) => theme.colors.mutedForeground};
            }
        }

        form.passwordWizardForm
        {
            display: flex;
            flex-direction: column;
            gap: ${({theme}) => theme.spacing.lg};

            .progressIcon
            {
                animation-name: rotateProgress;
                animation-duration: 4s;
                animation-timing-function: linear;
                animation-iteration-count: infinite;
            }
        }
    }

    .right
    {
        width: ${({theme}) => theme.breakPoints.xs};
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.md};
        
        div.terms
        {
            overflow: scroll;
            
        }
    }
`